import React, { useState } from 'react';
import { Dialog, DialogTitle, Button, Box, CircularProgress, Typography } from '@mui/material';

const StoryUpload = ({ open, onClose, onUpload, isUploading, uploadProgress }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [preview, setPreview] = useState(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFile(file);
            setPreview(URL.createObjectURL(file));
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (file) {
            setSelectedFile(file);
            setPreview(URL.createObjectURL(file));
        }
    };

    const handleUpload = () => {
        if (selectedFile) {
            onUpload(selectedFile);
            // Optionally reset state after uploading:
            setSelectedFile(null);
            setPreview(null);
        }
    };


    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Upload Your Story</DialogTitle>
            <Box
                sx={{
                    width: '100%',
                    maxWidth: '100%',
                    aspectRatio: '16 / 9',
                    backgroundColor: '#f0f0f0',
                    border: '2px dashed #ccc',
                    margin: '20px auto',
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                }}
                onDrop={handleDrop}
                onDragOver={(e) => e.preventDefault()}
            >
                {preview ? (
                    selectedFile.type.startsWith('video/') ? (
                        <Box
                            component="video"
                            src={preview}
                            controls
                            sx={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                            }}
                        />
                    ) : (
                        <Box
                            component="img"
                            src={preview}
                            alt="Preview"
                            sx={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                            }}
                        />
                    )
                ) : (
                    <Box
                        sx={{
                            textAlign: 'center',
                            color: '#888',
                            fontSize: '16px',
                            padding: '20px',
                        }}
                    >
                        <p>Drag & drop a photo or video</p>
                        <p>(16:9 Aspect Ratio Recommended, 5 MB Max)</p>
                    </Box>
                )}
                <input
                    type="file"
                    accept="image/*,video/*"
                    onChange={handleFileChange}
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        opacity: 0,
                        cursor: 'pointer',
                    }}
                />
            </Box>
            {isUploading && (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                    <CircularProgress variant="determinate" value={uploadProgress} />
                    <Typography variant="body1" sx={{ ml: 2 }}>{uploadProgress}%</Typography>
                </Box>
            )}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    margin: '10px auto 20px auto',
                    gap: '10px',
                }}
            >
                <Button
                    onClick={onClose}
                    sx={{
                        color: '#C4A484',
                        border: '1px solid #C4A484',
                        mr: '5px',
                    }}
                    disabled={isUploading}
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleUpload}
                    disabled={!selectedFile || isUploading}
                    variant="contained"
                    sx={{
                        backgroundColor: '#C4A484',
                        '&:hover': { backgroundColor: '#C4A484' },
                    }}
                >
                    {isUploading ? 'Uploading...' : 'Upload'}
                </Button>
            </Box>
        </Dialog>
    );
};

export default StoryUpload;